import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'
import * as widget from '../../../widget'

/** Renders the active Mosaic slideout widget in a shared page overlay. */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.overlay.slideout.Component,
    widget.Component,
  ],
  selector: 'atn-mosaic-slideout',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.endUser.currentRendering.Feature} */
  public readonly currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )

  /** Close the active slideout widget. */
  public closeSlideout(source: string): void {
    this.currentRendering.subfeatures.slideout.actions.setSlideout
      .from(source)
      .dispatch({ widgetRef: undefined })
  }
}
